import { render, staticRenderFns } from "./Shareholder.vue?vue&type=template&id=1bb276be&scoped=true"
import script from "./Shareholder.vue?vue&type=script&lang=js"
export * from "./Shareholder.vue?vue&type=script&lang=js"
import style0 from "./Shareholder.vue?vue&type=style&index=0&id=1bb276be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb276be",
  null
  
)

export default component.exports